import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        let noTawk = ["/directdebitsettings", "/eventlogs", "/pricingmodel", "/contractcommit", "/invoice", "/bucket", "/cwinvoice", "/tenantsummary", "/guardianfileviewer", "/pricingtool"]
        let noNavMenu = ["/restore", "/check", "/directdebitsettings", "/eventlogs", "/orglogs","/contractcommit", "/main", "/bucket", "/pricingmodel", "/masteradmin", "/reseller", "/ContractCommit", "invoice", "/settings", "/jobmanagement", "/tenantsummary", "/termsadmin", "/pricingtool", "/pricemanagement", "/guardianfileviewer", "/knownerrors", "/errorsuppression", "/managesuppressions", "/connectwisesync", "/connectwisesyncstatus"]
        let pathName = window.location.pathname;
        let navMenu = (<NavMenu />);
        let tawkWidget = null;

        if (noNavMenu.includes(pathName.toLowerCase())) {
            navMenu = null;
        }
        let tawkChatValue = true;

        const tawkChatSession = sessionStorage.getItem('TawkChat');

        if (tawkChatSession) {
            try {
                const parsed = JSON.parse(tawkChatSession);
                if (parsed && typeof parsed.TawkChat === 'boolean') {
                    tawkChatValue = parsed.TawkChat;
                }
            } catch (error) {
                console.error("Failed to parse TawkChat session:", error);
            }
        }
        if (!noTawk.includes(pathName.toLowerCase()) && tawkChatValue === true) {
            if ((!window.location.hostname.includes("365demo")) && (!window.location.hostname.includes("localhost")) && (!window.location.hostname.includes("preview"))) {
            //if (true) {

                tawkWidget = (
                    <Helmet>
                        <script type="text/javascript" src="./tawkscript.js" async={true} />
                    </Helmet>
                );
            }
        }
        return (
            <div>
                {tawkWidget}
                <Container fluid className="p-0">
                    {navMenu}
                    {this.props.children}
                </Container>
            </div>
        );
    }
}
